if (!customElements.get('di-theme-rail')) {
  customElements.define('di-theme-rail', class extends HTMLElement {
    connectedCallback() {
      if (this.loaded) return;
      this.controller = new AbortController();
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            this.observer.disconnect();
            this.load();
          }
        }, { rootMargin: '400px 0px' });
        this.observer.observe(this);
      } else {
        this.load();
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
      this.controller?.abort();
      this.loaded = false;
    }

    async fetchProducts(url, signal) {
      const response = await fetch(url, { signal });
      if (!response.ok) throw new Error('Theme products unavailable');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const source = html.querySelector('[data-theme-products]');
      const count = Number(source?.dataset.count);
      if (!source || !Number.isInteger(count) || count < 0) throw new Error('Invalid theme products');
      return { source, count };
    }

    async load() {
      const { signal } = this.controller;
      try {
        let result;
        let animated = false;
        if (this.dataset.animatedUrl) {
          try {
            result = await this.fetchProducts(this.dataset.animatedUrl, signal);
            animated = result.count >= 2;
          } catch (error) {
            if (signal.aborted) return;
          }
        }
        if (signal.aborted) return;
        if (!animated) result = await this.fetchProducts(this.dataset.url, signal);
        if (signal.aborted) return;
        const { source, count } = result;
        if (count < 1) {
          this.hidden = true;
          return;
        }
        const cards = [...source.querySelectorAll('li[data-product-id]')]
          .filter(card => card.dataset.productId !== this.dataset.productId)
          .slice(0, 12);
        if (!cards.length) {
          this.hidden = true;
          return;
        }
        const list = this.querySelector('.di-theme-rail__list');
        list.querySelectorAll('[data-product-id]').forEach(card => card.remove());
        const last = list.querySelector('.di-theme-rail__all');
        cards.forEach(card => list.insertBefore(card, last));
        const allLink = this.querySelector('[data-label]');
        const label = (animated ? this.dataset.animatedLabel : allLink.dataset.label).replace('[count]', String(count));
        this.querySelectorAll('[data-see-all]').forEach(link => {
          link.textContent = label;
          link.href = animated ? this.dataset.animatedLink : this.dataset.link;
        });
        this.querySelector('[data-rail-content]').hidden = false;
        this.hidden = false;
        this.loaded = true;

        const buttons = [...this.querySelectorAll('[data-direction]')];
        const update = () => {
          const bounds = list.getBoundingClientRect();
          buttons[0].disabled = list.firstElementChild.getBoundingClientRect().left >= bounds.left - 2;
          buttons[1].disabled = last.getBoundingClientRect().right <= bounds.right + 2;
        };
        buttons.forEach(button => button.addEventListener('click', () => {
          const step = list.children[1].offsetLeft - list.children[0].offsetLeft;
          list.scrollBy({
            left: Number(button.dataset.direction) * step,
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
          });
        }, { signal }));
        list.addEventListener('scroll', update, { passive: true, signal });
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(update);
          this.resizeObserver.observe(list);
        } else {
          window.addEventListener('resize', update, { signal });
        }
        update();
      } catch (error) {
        if (!signal.aborted) this.hidden = true;
      }
    }
  });
}
